import { LitElement, html, css } from '@hh/global.js'

class HHRadioWrapper extends LitElement {
  static properties = {
    disabled: {
      type: Boolean,
      reflect: true,
    },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  firstUpdated() {
    this.disabled = this.input.disabled
    this.checked = this.input.checked
  }

  get input() {
    const slot = this.shadowRoot?.querySelector(`slot[name='input']`)
    return slot?.assignedNodes()[0] ?? null
  }

  render() {
    return html`
      <slot name="input" part="input"></slot>
      <slot name="label" part="label"></slot>
    `
  }

  static styles = css`
    *,
    *::before,
    *::after {
      box-sizing: border-box;
    }

    :host {
      display: inline-flex;
      align-items: flex-start;
      column-gap: var(--hh-column-gap, 0.5rem);
    }

    ::slotted(input) {
      appearance: none;
      touch-action: none;
      margin: 0;
      width: var(--hh-width, 2.4rem);
      height: var(--hh-height, 2.4rem);
      border: 1px solid var(--hh-color-input-border, #646464);
      border-radius: var(--hh-border-radius, 50%);
      position: relative;
      cursor: pointer;
    }

    ::slotted(input)::before {
      content: '';
      pointer-events: none;
      width: calc(var(--hh-width, 2.4rem) / var(--hh-dot-to-border-ratio, 2));
      height: calc(var(--hh-height, 2.4rem) / var(--hh-dot-to-border-ratio, 2));
      border-radius: var(--hh-border-radius, 50%);
      background-color: var(--hh-color, #646464);
      scale: 0;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    :host(:hover) ::slotted(input:not(:disabled):hover),
    :host(:not([disabled]):hover) ::slotted(label:hover) {
      border-color: var(--hh-color-input-border-hover, #646464);
      color: var(--hh-color-label-hover);
    }

    ::slotted(input:checked)::before {
      scale: 1;
    }

    ::slotted(input:focus) {
      border: 1px solid var(--hh-color, #646464) !important;
    }

    ::slotted(input:disabled) {
      border-color: var(--hh-color-input-border-disabled);
      cursor: default;
    }

    ::slotted(label) {
      cursor: pointer;
      max-width: var(--hh-label-max-width, 21rem);
      color: var(--hh-color-label);
      transform: translateY(-3px);
    }

    :host([disabled]) ::slotted(label) {
      cursor: default;
      color: var(--hh-color-label-disabled);
    }
  `
}

customElements.define('hh-radio-wrapper', HHRadioWrapper)
